import { render, staticRenderFns } from "./FormatNumberic.vue?vue&type=template&id=ebfc86cc&"
import script from "./FormatNumberic.vue?vue&type=script&lang=js&"
export * from "./FormatNumberic.vue?vue&type=script&lang=js&"
import style0 from "./FormatNumberic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports